var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 224.8 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#202843",
    d: "M47.7 32.4c4.4-12.8-2.5-26.8-15.3-31.1S5.7 3.8 1.3 16.6c-4.4 12.8 2.5 26.7 15.3 31.1 12.8 4.4 26.8-2.4 31.1-15.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFC94C",
    d: "M3.8 37.6c3.8-1.8 16.8-8.2 19.3-9.7 2.1-1.2 5.2-3 5.2-3l1.3 2.7 2 13.3 1.5-.9 1-18.6c3.1-2 5.9-3.9 8.8-5.9 1.1-.7 2.1-1.5 3.2-2.2-.4-.7-.7-1.3-1.2-2L41.6 13c-3.2 1.5-6.2 2.9-9.5 4.7L15.5 9.2l-1.5.9 10.6 8.4 1.7 2.5s-3.1 1.8-5.2 3c-2.7 1.5-14.8 9.6-18.2 12 .2.5.6 1 .9 1.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "current",
    d: "M219.7 23.9c-1.5-2.2-4.1-3.5-6.8-3.5-4.3 0-7.3 3.7-7.3 8.2s2.9 8.3 7.3 8.3c2.8 0 5.3-1.5 6.8-3.9v-9.1m.3-4.8v-2.7h4.7v24.5h-4.9v-2.8c-1.8 2-4.2 3.4-7.7 3.4-7 0-11.5-5.6-11.5-12.8s4.5-12.8 11.5-12.8c3-.2 5.9 1 7.9 3.2zM190.9 10.1c0-1.9 1.6-3.4 3.4-3.4 1.9 0 3.4 1.6 3.4 3.4 0 1.9-1.5 3.4-3.4 3.4s-3.4-1.5-3.4-3.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M191.8 16.4h5.1v24.5h-5.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "current",
    d: "M181.8 23.9c-1.5-2.2-4.1-3.5-6.8-3.5-4.3 0-7.3 3.7-7.3 8.2s2.9 8.3 7.3 8.3c2.8 0 5.3-1.5 6.8-3.9v-9.1m.1-16.6h5v33.6H182v-2.8c-1.8 2-4.2 3.4-7.7 3.4-7 0-11.5-5.6-11.5-12.8s4.5-12.8 11.5-12.8c2.8-.1 5.6 1 7.6 3V7.3zM141.1 26.2H155c-.5-3.4-3.4-6-6.9-6-1.8 0-3.4.7-4.7 1.9-1.2 1.1-2 2.5-2.3 4.1m7.3 15.3c2.1 0 4.1-.4 6-1.2 1.8-.8 3.5-2.1 4.8-3.6l-3-3.2c-1 1-2.1 1.9-3.4 2.6-1.3.6-2.8 1-4.3.9-3.8 0-7-2.8-7.6-6.6H160v-.2c0-.6.1-1.2.1-1.8 0-7-5-12.7-12-12.7s-12.3 5.5-12.3 12.9c.1 7.5 5.3 12.9 12.6 12.9zM114.5 33.4c1.5 2.2 4.1 3.5 6.8 3.5 4.3 0 7.3-3.7 7.3-8.2s-2.9-8.3-7.3-8.3c-2.8 0-5.3 1.5-6.8 3.9v9.1m-.1 5V50h-5V16.4h4.9v2.8c1.8-2 4.2-3.4 7.7-3.4 7 0 11.5 5.6 11.5 12.8S129 41.5 122 41.5c-2.8 0-5.6-1.1-7.6-3.1zM91.8 28.3l-8.6-11.9h6.1l5.8 8.1 5.7-8.1h6.1l-8.7 11.9 9.1 12.6h-6.2L95 32.2l-6.2 8.7h-6.1l9.1-12.6M66.8 26.5h12.8v-4.8H66.8V13h13.9V8.1H61.3v32.8h19.5v-4.8h-14v-9.6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpedia);
export default __webpack_public_path__ + "static/media/expedia.a108e7732cc940d64e72307144311c5f.svg";
export { ForwardRef as ReactComponent };